module.exports = __webpack_public_path__ + "static/img/range.239d5e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/range.jpg
// module id = cC64
// module chunks = 1